import PollCreationPanelContainer from './component';

export default PollCreationPanelContainer;
